import axios from "axios";

export default axios.create({
    baseURL:`${(<any>window).baseUrl}`
});

// import axios from "axios";

// let baseUrlPromise: Promise<string> | null = null;
// async function waitForBaseUrl(): Promise<string> {
//     if (baseUrlPromise) {
//         return baseUrlPromise;
//     }
//     baseUrlPromise = (async () => {
//         for (let i = 0; i < 5; i++) {
//             const url = (<any>window).baseUrl;

//             if (url) return url;

//             await new Promise(r => setTimeout(r, (500 * (i + 1))));
//         }
//         alert('مشکلی پیش آمده، صفحه را مجددا بازگذاری کنید.')
//         throw new Error('baseUrl not found');
//     })();

//     return baseUrlPromise;
// }

// const instance = axios.create({
//     baseURL: ''
// });

// instance.interceptors.request.use(async (config) => {
//     config.baseURL = await waitForBaseUrl();
//     return config;
// });

// export default instance;